import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { GetDirectorLeaveList, GetLeaveRejoinList, GetCompOffLeaveList } from "../../Repository/Api";
import { Link } from "react-router-dom";
import moment from "moment";
import { errorMsg } from "../Toastify";
import MUIDataTable from "mui-datatables";
import { DateRangePicker } from "react-date-range";
import { enUS } from 'date-fns/locale';
const DirectorLeaverequest = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [leaveList, setLeaveList] = useState([]);
  console.log(leaveList, "setleavlist")
  const [dateFilterOpen, setDateFilterOpen] = useState(false)
  const filterIntialState = [
    {
      startDate: null,
      endDate: new Date('2030-01-01'),
      key: "selection",
    },
  ]
  const dfm = (date) => {
    return moment(date).format("DD/MM/yyyy")
  }
  const [range, setRange] = useState(filterIntialState);
  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const dateFilterRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
      setDateFilterOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getLeaveList();
    getCompoffLeave()
  }, [range]);

  const [activetag, setActivetag] = useState(0);
  const linkstag = ["Applied Leave", "Cancelled Leave", "Rejoin", "Comp Off Request"];
  const showSelectedtag = (index) => {
    setActivetag(index);
  };

  const [active, setActive] = useState(0);
  const [activetwo, setActivetwo] = useState(0);
  console.log(activetag, active, "displa")
  const links = [
    "Pending With Me",
    "Pending",
    "Approved",
    "Rejected",
    "Intimated (Out of Station)",
    "Archives",
  ];
  const linkstwo = [
    "Pending With Me",
    "Pending",
    "Approved",
  ];
  const showSelected = (index) => {
    setActive(index);
  };
  const showSelectedtwo = (index) => {
    setActivetwo(index);
  };

  const [activeone, setActiveone] = useState(0);
  const [activethree, setActivethree] = useState(0);
  const linksone = ["Pending", "Approved", "Rejected"];
  const showSelectedone = (index) => {
    setActiveone(index);
  };
  const showSelectedthree = (index) => {
    setActivethree(index);
  };

  const [compofflist, setCompofflist] = useState([])
  const getCompoffLeave = async () => {
    const response = await GetCompOffLeaveList(token);
    if (response && response.statusCode === 200) {
      setCompofflist(response?.data?.comp_off_details.filter(item => {
        const startDate = new Date(item.date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return (startDate >= rangeStartDate && startDate <= rangeEndDate);
      }));
    } else {
      errorMsg(response.message);
    }
  };

  const [dummyleaveList, setdummyLeaveList] = useState([]);
  const [searchText, setSearchText] = useState("");


  const SearchfilteredData = dummyleaveList?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setLeaveList(SearchfilteredData);
      setCurrentPage(1)
    } else {
      setLeaveList(dummyleaveList);
    }
  }, [searchText, dummyleaveList]);
  const getLeaveList = async () => {
    const response = await GetDirectorLeaveList(token);
    if (response && response.statusCode === 200) {
      setLeaveList(response?.data?.leave_details, "setleavlist");
      setdummyLeaveList(
        response?.data?.leave_details.filter(item => {
          const startDate = new Date(item.start_date);
          const endDate = new Date(item.end_date);
          const rangeStartDate = new Date(range[0].startDate)
          const rangeEndDate = new Date(range[0].endDate)
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          rangeStartDate.setHours(0, 0, 0, 0);
          rangeEndDate.setHours(0, 0, 0, 0);
          return ((startDate >= rangeStartDate && startDate <= rangeEndDate) || (endDate >= rangeStartDate && endDate <= rangeEndDate));
        })
      );
    } else {
      errorMsg(response.message);
    }
  };

  // Rejoin api-----------------------/
  const [RejoinList, setRejoinList] = useState([]);

  const GetRejoinList = async () => {
    const response = await GetLeaveRejoinList(token, linkstwo[activetwo].toLowerCase().split(' ')[0])
    if (response && response?.statusCode === 200) {
      const rejoin = response?.data?.joining_letter.map((rejoinData) => ({
        first_name: rejoinData.leave_detail.first_name,
        last_name: rejoinData.leave_detail.last_name,
        designation: rejoinData.leave_detail.designation,
        start_date: rejoinData.start_date,
        end_date: rejoinData.end_date,
        nature_of_leave: rejoinData.leave_detail.nature_of_leave,
        no_of_days: rejoinData.no_of_days,
        id: rejoinData.leave_detail.id,
        admin_status: rejoinData.admin_status
      })).filter(item => {
        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return (startDate >= rangeStartDate && startDate <= rangeEndDate || endDate >= rangeStartDate && endDate <= rangeEndDate);
      })
      setRejoinList(rejoin)
    }
  }

  useEffect(() => {
    GetRejoinList()
  }, [activetwo, range])

  const [currentPage, setCurrentPage] = useState(1);
  const currentItems = leaveList?.filter((a) => a.director_status === 'pending')

  const pwmcurrentItems = leaveList?.filter(
    (leaveList) =>
      leaveList.director_status === "pending" &&
      leaveList.admin_status === "forwarded"
  )

  const approvedcurrentItems = leaveList?.filter(
    (leaveList) =>
      leaveList.director_status === "approved"
  )

  const rejectedCurrentItems = leaveList?.filter(
    (leaveList) =>
      leaveList.director_status === "rejected"
  )

  
  const IntimatedCurrentItems = leaveList?.filter(
    (leaveList) =>
      (( leaveList.director_status === "intimated") &&
      (leaveList.already_viewed === false))
  )

  const ArchiveItems = leaveList?.filter(
    (leaveList) =>
      (( leaveList.director_status === "intimated") &&
      (leaveList.already_viewed === true))
  )

  const CancelledPendingItems = leaveList?.filter(
    (leaveList) =>
      leaveList.cancellation_director_status === "pending"
  )

  const CancelledApprovedItems = leaveList?.filter(
    (leaveList) =>
      leaveList.cancellation_director_status === "approved"
  )

  const CancelledRejectedItems = leaveList?.filter(
    (leaveList) =>
      leaveList.cancellation_director_status === "rejected"
  )

  const CompoffPendingItems = compofflist?.filter(
    (leaveList) =>
      leaveList.director_status === "pending"
  )

  const CompoffApprovedItems = compofflist?.filter(
    (leaveList) =>
      leaveList.director_status === "approved"
  )

  const CompoffRejectedItems = compofflist?.filter(
    (leaveList) =>
      leaveList.director_status === "rejected"
  )

  const RejoinpendingwithmeItems = RejoinList.filter((a) => a.admin_status === "approved")
  const RejoinpendingItems = RejoinList.filter((a) => a.admin_status === "pending")
  const RejoinApprovedItems = RejoinList
  // ----------------------------------------------

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    viewColumns: false,
    setRowProps: (row, dataIndex, rowIndex) => {
      console.log(row, "nitttrror")
      if ((active === 4) && (row[9] === true)) {
        return {
          style: { backgroundColor: "#ffffff" }
        };
      }
      return {};
    }
  };
  const readColor = (active === 4 ? "gray" : "black")
  const cancelColor = "red"
  const columns = [

    {
      name: "first_name",
      label: "Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const lastName = tableMeta.rowData[1];
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {value} {lastName}
            </div>
          )
        },
      },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: {
        display: false,
        filter: false
      },
    },

    {
      name: "designation",
      label: "Designation	",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {value}
            </div>
          )
        },
      },
    },
    {
      name: "created_at",
      label: "Applied On",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {moment(value).format(
                "DD MMM YY")}
            </div>
          )
        },
      },
    },
    {
      name: "start_date",
      label: "Duration",
      options: {
        customBodyRender: (value, tableMeta) => {
          const endDate = tableMeta.rowData[5]
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {moment(value).format("DD MMM YY")
                + "-" + moment(endDate).format("DD MMM YY")}
            </div>
          )

        },
        filter: false
      }
    },
    {
      name: "end_date",
      label: "End Date",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "nature_of_leave",
      label: "Types",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {value}
            </div>
          )
        },
      },
    },
    {
      name: "no_of_days",
      label: "Days",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {value}
            </div>
          )
        },
      },
    },
    {
      name: "rejoin_date",
      label: "Rejoin Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {value ? moment(value).format(
                "DD MMM YY") : "-"}
            </div>
          )
        },
        display: (activetag === 0 && active === 2)
      },
    },
    {
      name: "medical_certificate",
      label: "Medical Certificate",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isViewed = tableMeta.rowData[11];
          const isCancelled = tableMeta.rowData[12];
          const isRejoined = tableMeta.rowData[8] !== "";
          return (
            <div style={{ color: `${isCancelled ? cancelColor : isViewed ? readColor : "black"}` }}>
              {isRejoined ? (value ? "Submitted" : "Not Submitted") : "-"}
            </div>
          )
        },
        display: (activetag === 0 && active === 2)
      },
    },
    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Director/DirectorSpecificrequestview/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      }
    },
    {
      name: "already_viewed",
      label: "already_viewed",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "cancel",
      label: "cancel",
      options: {
        display: false,
        filter: false
      },
    },
  ];
  const compOffColumns = [
    {
      name: "first_name",
      label: "Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const lastName = tableMeta.rowData[1];
          return `${value} ${lastName}`;
        },
      },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: {
        display: false,
      },
    },
    {
      name: "designation",
      label: "Designation",
    },
    {
      name: "date",
      label: "Worked Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            moment(value).format(
              "DD MMM YY"
            )
          )
        }
      }
    },
    {
      name: "expiry_date",
      label: "Expire Date	",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            moment(value).format(
              "DD MMM YY"
            )
          )
        }
      }
    },
    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Director/DirectorSpecificComprequestview/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      },

    },
  ];
  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4 ">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="labeltitle">Leave Request</h6>
                  </div>
                  <div className="col-lg-7">
                    <ul className="searchtopflex ">
                      {linkstag.map((linkt, index) => {
                        return (
                          <li
                            onClick={() => showSelectedtag(index)}
                            key={linkt}
                            className={
                              activetag === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {linkt}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="mt-4">
                  {activetag === 0 && (
                    <>
                      <ul className="searchtopflex mt-4">
                        {links.map((link, index) => {
                          return (
                            <li
                              onClick={() => { showSelected(index); setRange(filterIntialState) }}
                              key={link}
                              className={
                                active === index
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {link}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={active === 0 ? pwmcurrentItems : active === 1 ? currentItems : active === 2 ? approvedcurrentItems : active === 3 ? rejectedCurrentItems : active === 4 ?IntimatedCurrentItems : active === 5 ? ArchiveItems : ""}
                        columns={columns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                  {activetag === 1 && (
                    <>
                      <ul className="searchtopflex">
                        {linksone.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedone(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activeone === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <table className="table table-hover mt-5">
                        <MUIDataTable
                          data={activeone === 0 ? CancelledPendingItems : activeone === 1 ? CancelledApprovedItems : activeone === 2 ? CancelledRejectedItems : ""}
                          columns={columns}
                          options={options}
                          className="mt-3"
                        />
                      </table>
                    </>
                  )}
                  {activetag === 2 && (
                    <>
                      <ul className="searchtopflex">
                        {linkstwo.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedtwo(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activetwo === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => { setRange(filterIntialState); setRange(filterIntialState) }}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={activetwo === 0 ? RejoinpendingwithmeItems : activetwo === 1 ? RejoinpendingItems : activetwo === 2 ? RejoinApprovedItems : ""}
                        columns={columns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                  {activetag === 3 && (
                    <>
                      <ul className="searchtopflex">
                        {linksone.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedthree(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activethree === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => { setRange(filterIntialState); setRange(filterIntialState) }}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={activethree === 0 ? CompoffPendingItems : activethree === 1 ? CompoffApprovedItems : activethree === 2 ? CompoffRejectedItems : ""}
                        columns={compOffColumns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorLeaverequest;
